module.exports = __webpack_public_path__ + "img/starfish.4d39998d.png";